import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const BenefitsHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData = labels.menuPages?.sellCar?.benefitsHeader || {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center mb-16"
    >
      <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 max-w-4xl mx-auto">
        {headerData.title || "Fördelarna med BILENIA"}
      </h2>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto">
        {headerData.description ||
          "Vi kombinerar teknologi, expertis och personlig service för att ge dig den bästa bilförsäljningsupplevelsen."}
      </p>
    </motion.div>
  );
};

export default BenefitsHeader;
